import repository from '@/api/repository';
import { DIRECT_DEBIT } from '@/constants/repository';

export interface DirectDebitPaymentOrderDTO {
  groups: Array<{
    creditor: {
      name: string;
      iban: string;
    };
    transactions: Array<{
      debtor: {
        name: string;
        iban: string;
        mandate: {
          id: string;
          dateOfSignature: string;
        };
      };
      amount: number;
      reference: string;
      description: string;
    }>;
  }>;
}

export default {
  post(dto: DirectDebitPaymentOrderDTO) {
    return repository.post<string>(DIRECT_DEBIT, dto);
  },
};
